export default {
    FormData: {
        APPLICATION: "application",
        FILES: "files"
    },
    Auth: {
        TOKEN: "token",
        COOKIE: "GlobalAuthUser",
        STATUS_LOADING: "loading",
        STATUS_SUCCESS: "success",
        STATUS_ERROR: "error"
    },
    LocalStorage: {
        LAST_USED_CUSTOMER_APPLICATION_ID: "lastUsedCustomerApplicationId"
    }
}